<template>
    <a-drawer
        :title="abstract_id ? $t('submission.abstract_edit.edit_abstract' /*稿件编辑*/) : $t('submission.abstract_edit.add_abstract' /*新增稿件*/)"
        width="1000px"
        id="abstractDrawer"
        placement="right"
        :closable="true"
        :visible="visible"
        @close="visible = false"
    >
        <div v-if="!info.channel_id">
            <a-form>
                <a-form-item :label="$t('submission.abstract_edit.select_channel' /*选择渠道*/)">
                    <a-select v-model="info.channel_id" @change="handleChangeChannelEvent">
                        <a-select-option v-for="(item, index) in channelList" :key="index" :value="item.channel_id">{{ item.title }}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </div>
        <div v-if="info.channel_id" style="margin-bottom: 50px">
            <a-collapse v-model="activeKey">
                <a-collapse-panel key="1" :header="$t('submission.abstract_edit.submitter_info' /*提交者信息*/)" :forceRender="true" v-if="type == 'edit'">
                    <a-row :gutter="[15, 15]">
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.user_id' /*用户ID*/) }}：</span>
                            <span>{{ info.SubmitInfo.user_id }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.name' /*姓名*/) }}：</span>
                            <span>{{ info.SubmitInfo.real_name }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.gender' /*性别*/) }}：</span>
                            <span>{{ info.SubmitInfo.sex }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.family_name' /*姓拼音*/) }}：</span>
                            <span>{{ info.SubmitInfo.family_name }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.given_name' /*名拼音*/) }}：</span>
                            <span>{{ info.SubmitInfo.given_name }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.highest_degree' /*最高学历*/) }}：</span>
                            <span>{{ info.SubmitInfo.degree }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.technical_title' /*技术职称*/) }}：</span>
                            <span>{{ info.SubmitInfo.clinical_title }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.province' /*所属省市*/) }}：</span>
                            <span>{{ info.SubmitInfo.province_name }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.area' /*所属地区*/) }}：</span>
                            <span>{{ info.SubmitInfo.city_name }} {{ info.SubmitInfo.area_name }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.administrative_position' /*行政职务*/) }}：</span>
                            <span></span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.workplace' /*工作单位*/) }}：</span>
                            <span>{{ info.SubmitInfo.org_cnname }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.department' /*科室部门*/) }}：</span>
                            <span>{{ info.SubmitInfo.department }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.address' /*门牌地址*/) }}：</span>
                            <span>{{ info.SubmitInfo.address }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.postal_code' /*邮政编码*/) }}：</span>
                            <span>{{ info.SubmitInfo.zipcode }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.mobile' /*联系手机*/) }}：</span>
                            <span>{{ info.SubmitInfo.mobile }}</span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.work_phone' /*单位电话*/) }}：</span>
                            <span></span>
                        </a-col>
                        <a-col :xs="8" :sm="8" :lg="8" :xl="8" :xxl="8">
                            <span>{{ $t('submission.abstract_edit.email' /*邮箱*/) }}：</span>
                            <span>{{ info.SubmitInfo.email }}</span>
                        </a-col>
                    </a-row>
                </a-collapse-panel>

                <a-collapse-panel key="2" :header="$t('submission.abstract_edit.all_orgs' /*论文作者所有单位*/)" :forceRender="true" v-if="type == 'edit'">
                    <div class="org-list">
                        <table class="author-org mt5">
                            <thead>
                                <tr>
                                    <th>{{ $t('submission.abstract_edit.org_name' /*单位名称*/) }}</th>
                                    <th>{{ $t('submission.abstract_edit.org_address' /*单位地址*/) }}</th>
                                    <th>{{ $t('submission.abstract_edit.org_postal_code' /*单位邮编*/) }}</th>
                                    <th>{{ $t('submission.abstract_edit.action' /*操作*/) }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in organize_list" :key="index">
                                    <td class="t-c">
                                        {{ item.org_cnname }}
                                    </td>
                                    <td class="t-c">
                                        {{ item.address }}
                                    </td>
                                    <td class="t-c">
                                        {{ item.zipcode }}
                                    </td>
                                    <td class="t-c">
                                        <a-icon @click="handlePrevEvent(index)" class="icon-theme pointer" type="vertical-align-top" />
                                        <a-icon @click="handleNextEvent(index)" class="icon-theme pointer ml5" type="vertical-align-bottom" />
                                        <a-icon class="icon-theme pointer ml5" type="edit" @click="$refs.addOrgRef.show(item)" />
                                        <a-icon class="icon-delete pointer ml5" type="delete" @click="handleDeleteOrgEvent(item.id)" />
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="4">
                                        <a-button ghost type="primary" @click="$refs.addOrgRef.show({ abstract_id })">{{ $t('submission.abstract_edit.add_org' /*添加单位*/) }}</a-button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </a-collapse-panel>

                <a-collapse-panel key="4" :header="$t('submission.abstract_edit.all_authors' /*所有作者信息*/)" :forceRender="true" v-if="type == 'edit'">
                    <all-author :abstract_id="abstract_id" :channel_id="info.channel_id" ref="allAuthorRef"></all-author>
                </a-collapse-panel>

                <a-collapse-panel key="5" :header="$t('submission.abstract_edit.abstract_content' /*稿件内容*/)" :forceRender="true">
                    <contribute-form ref="abstractContentRef" :list="formList" :model="{ ...info, ...info.other_infos }" :channel_id="info.channel_id"></contribute-form>
                </a-collapse-panel>

                <a-collapse-panel key="6" :header="$t('submission.abstract_edit.other_settings' /*其他设置*/)" :forceRender="true">
                    <a-form :form="form">
                        <a-form-item :label="$t('submission.abstract_edit.submission_status' /*投稿状态*/)">
                            <a-radio-group v-decorator="['is_finish', { rules: [{ required: true, message: $t('submission.abstract_edit.select_submission_status' /*请选择投稿状态*/) }] }]">
                                <a-radio :value="1">
                                    {{ $t('submission.abstract_edit.completed' /*已完成*/) }}
                                </a-radio>
                                <a-radio :value="0">
                                    {{ $t('submission.abstract_edit.not_completed' /*未完成*/) }}
                                </a-radio>
                            </a-radio-group>
                        </a-form-item>

                        <a-form-item :label="$t('submission.abstract_edit.final_acceptance_type' /*最终录用形式*/)">
                            <a-radio-group v-decorator="['review_results', { rules: [{ required: true, message: $t('submission.abstract_edit.select_acceptance_type' /*请选择最终录用形式*/) }] }]">
                                <a-radio :value="0">
                                    {{ $t('submission.abstract_edit.no_acceptance_type' /*无最终录用类型*/) }}
                                </a-radio>
                                <a-radio v-for="(item, index) in hireList" :key="index" :value="item.id">{{ item.typename_cn }}</a-radio>
                            </a-radio-group>
                        </a-form-item>

                        <a-form-item :label="$t('submission.abstract_edit.paper_number' /*论文编号*/)">
                            <a-input v-decorator="['abstract_num', { rules: [{ required: false, message: $t('submission.abstract_edit.enter_paper_number' /*请输入论文编号*/) }] }]"></a-input>
                        </a-form-item>

                        <a-form-item :label="$t('submission.abstract_edit.show_electronic_poster' /*是否展示电子壁报*/)">
                            <a-radio-group
                                v-decorator="['is_show', { initialValue: 0, rules: [{ required: true, message: $t('submission.abstract_edit.select_show_poster' /*请选择是否展示电子壁报*/) }] }]"
                            >
                                <a-radio :value="0">
                                    {{ $t('submission.abstract_edit.not_show' /*不展示*/) }}
                                </a-radio>
                                <a-radio :value="1">
                                    {{ $t('submission.abstract_edit.show' /*展示*/) }}
                                </a-radio>
                            </a-radio-group>
                        </a-form-item>

                        <a-form-item :label="$t('submission.abstract_edit.accept' /*是否接受*/)">
                            <a-radio-group v-decorator="['acceptance_state', { rules: [{ required: true, message: $t('submission.abstract_edit.select_accept' /*请选择是否接受*/) }] }]">
                                <a-radio :value="0">
                                    {{ $t('submission.abstract_edit.not_show' /*不展示*/) }}
                                </a-radio>
                                <a-radio :value="1">
                                    {{ $t('submission.abstract_edit.show' /*展示*/) }}
                                </a-radio>
                            </a-radio-group>
                        </a-form-item>

                        <a-form-item :label="$t('submission.abstract_edit.feedback' /*反馈意见*/)">
                            <a-textarea v-decorator="['acceptance_remark']"></a-textarea>
                        </a-form-item>
                    </a-form>
                </a-collapse-panel>
            </a-collapse>
            <div
                :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1
                }"
            >
                <a-button :style="{ marginRight: '8px' }" @click="visible = false">
                    {{ $t('submission.abstract_edit.close' /*关闭*/) }}
                </a-button>
                <a-button type="primary" @click="handleSubmitEvent">
                    {{ $t('submission.abstract_edit.submit' /*提交*/) }}
                </a-button>
            </div>
        </div>
        <add-org
            ref="addOrgRef"
            @reset="
                getOrgList();
                $refs.allAuthorRef.getAuthorList();
            "
        ></add-org>
    </a-drawer>
</template>

<script>
const fields = ['is_finish', 'review_results', 'abstract_num', 'is_show', 'acceptance_state', 'acceptance_remark', 'show_annex'];
import addOrg from './add-org.vue';
import allAuthor from './all-author.vue';
import contributeForm from '@/components/contribute-form.vue';
import pick from 'lodash.pick';
export default {
    name: 'AbstractEdit',
    components: { addOrg, allAuthor, contributeForm },
    data() {
        return {
            activeKey: ['1'],
            visible: false,
            abstract_id: '',
            info: {
                channel_id: null
            },
            formList: [],
            form: this.$form.createForm(this),
            labelCol: {
                xs: { span: 6 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 17 },
                sm: { span: 17 }
            },
            channelList: [],
            type: 'add',
            hireList: [],
            organize_list: []
        };
    },
    computed: {},
    methods: {
        show(id) {
            this.info = {
                channel_id: null
            };
            this.abstract_id = id || '';
            this.visible = true;
            this.$nextTick(async () => {
                // 表单防注册
                fields.forEach(v => {
                    this.form.getFieldDecorator(v);
                });
                if (id) {
                    await this.getAbstractDetail();
                    this.getAbstractFormList();
                    this.type = 'edit';
                } else {
                    await this.getSubmissionChannelList();
                    this.type = 'add';
                }
            });
            this.getOrgList();
        },
        handleChangeChannelEvent() {
            this.getAbstractFormList();
        },
        /**
         * ##  单位排序
         */
        orgSort() {
            let sort = [];
            this.organize_list.forEach((item, index) => {
                sort.push({
                    data_id: Number(item.id),
                    sort: this.organize_list.length - index
                });
            });
            this.$request.post({ url: 'sortOrgList', data: { sort } });
        },
        // 获取稿件定义表单
        getAbstractFormList() {
            let channel_id = Number(this.info.channel_id) || null;
            this.$request.post({ url: 'getAuthorFormList', data: { abstract_id: this.abstract_id, channel_id, type: 24, status: 1 } }).then(res => {
                const { list } = res.data;
                this.formList = list;
            });
        },
        // 取消
        handleCancelEvent() {
            this.$refs.abstractContentRef.form.resetFields();
            this.form.resetFields();
            this.visible = false;
        },
        // 获取稿件详情
        getAbstractDetail() {
            return new Promise((resolve, reject) => {
                this.$request.post({ url: 'getAbstractListDetail', data: { abstract_id: this.abstract_id, show_author: 1, show_annex: 1 } }).then(res => {
                    const { data } = res;
                    this.info = data;
                    this.info = { ...data, ...data.annex_info, ...data.other_infos };
                    // 表单回显
                    this.form.setFieldsValue(pick(this.info, fields));
                    resolve();
                });
            });
        },
        async handleSubmitEvent() {
            const contentValues = await this.$refs.abstractContentRef.formVerifyFun();
            this.form.validateFields((errors, values) => {
                if (!errors) {
                    let data = {
                        ...values,
                        ...contentValues,
                        abstract_id: this.abstract_id,
                        channel_id: this.info.channel_id
                    };
                    console.log(JSON.stringify(data));
                    this.$request.post({ url: this.abstract_id ? 'editAbstract' : 'addAbstract', data: data }).then(res => {
                        this.abstract_id ? this.$message.success('修改成功') : this.$message.success('添加成功');
                        this.visible = false;
                        this.$emit('reset');
                    });
                } else {
                    this.$message.info('请填写必填项');
                }
            });
        },
        // 获取录用类型列表
        getHireList() {
            this.$request.post({ url: 'getHireList' }).then(res => {
                const { data } = res;
                this.hireList = data;
            });
        },
        // 单位上移
        handlePrevEvent(index) {
            if (index > 0) {
                const temp = this.organize_list[index];
                this.$set(this.organize_list, index, this.organize_list[index - 1]);
                this.$set(this.organize_list, index - 1, temp);
                this.orgSort();
            }
        },
        // 单位下移
        handleNextEvent(index) {
            // TODO: 下移功能
            if (index < this.organize_list.length - 1) {
                const temp = this.organize_list[index];
                this.$set(this.organize_list, index, this.organize_list[index + 1]);
                this.$set(this.organize_list, index + 1, temp);
                this.orgSort();
            }
        },
        // 删除单位
        handleDeleteOrgEvent(id) {
            this.$confirm({
                title: '提示',
                content: '是否删除该单位？',
                onOk: () => {
                    this.$request.post({ url: 'delOrgListItem', data: { id, abstract_id: this.abstract_id } }).then(res => {
                        this.$message.success('删除成功');
                        const list = this.organize_list.filter(item => item.id != id);
                        this.organize_list = list;
                        this.$refs.allAuthorRef.getAuthorList();
                    });
                }
            });
        },
        getOrgList() {
            this.$request.post({ url: 'getOrganizeList', data: { abstract_id: this.abstract_id } }).then(res => {
                const { List } = res.data;
                this.organize_list = List;
            });
        },
        getSubmissionChannelList() {
            return new Promise((resolve, reject) => {
                this.$request.post({ url: 'getSubmissionChannelList' }).then(res => {
                    const { list } = res.data;
                    this.channelList = list;
                    resolve();
                });
            });
        }
    },
    created() {},
    mounted() {
        this.getHireList();
    }
};
</script>
<style lang="less" scoped>
.author-org {
    width: 100%;
    border: 1px solid #f1f1f1;
    th {
        background-color: #f1f1f1;
    }
    th,
    td {
        line-height: 1.5;
        padding: 5px 8px;
        text-align: center;
    }
    tbody tr {
        border-bottom: 1px solid #f1f1f1;
        td {
            text-align: left;
        }
    }
    .icon-delete {
        padding: 5px;
        font-size: 16px;
        border-radius: 3px;
        color: #fff;
        background-color: @error-color;
    }
    .icon-theme {
        padding: 5px;
        font-size: 16px;
        border-radius: 3px;
        color: #fff;
        background-color: @theme;
    }
}
</style>
